import { DiscountList } from "../components/DiscountList";
import { useDiscountsControllerFindAll } from "../utils/api/kolektifOluşumAPI";
import type { DiscountDto } from "../utils/api/kolektifOluşumAPI.schemas";

const Discounts = () => {
  const { data, isLoading, error } = useDiscountsControllerFindAll();
  const discounts: DiscountDto[] = data?.data ?? [];

  if (isLoading) {
    return (
      <main className="min-h-screen bg-gradient-to-b from-[#0A0A0A] via-[#111111] to-[#0A0A0A]">
        <div className="absolute inset-0 bg-[url('/noise.png')] opacity-5 pointer-events-none"></div>
        <div className="relative pt-32 pb-12">
          <div className="flex justify-center items-center min-h-[400px]">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-400"></div>
          </div>
        </div>
      </main>
    );
  }

  if (error) {
    return (
      <main className="min-h-screen bg-gradient-to-b from-[#0A0A0A] via-[#111111] to-[#0A0A0A]">
        <div className="absolute inset-0 bg-[url('/noise.png')] opacity-5 pointer-events-none"></div>
        <div className="relative pt-32 pb-12">
          <div className="text-center text-red-400">
            <p>
              İndirimler yüklenirken bir hata oluştu. Lütfen tekrar deneyin.
            </p>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="min-h-screen bg-gradient-to-b from-[#0A0A0A] via-[#111111] to-[#0A0A0A]">
      <div className="absolute inset-0 bg-[url('/noise.png')] opacity-5 pointer-events-none"></div>
      <div className="relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-12">
          <div className="text-center mb-12">
            <h1 className="text-[40px] font-bold text-white mb-4">
              İndirimler
            </h1>
            <p className="text-xl text-gray-400">
              Kolektif Oluşum üyelerine özel indirimler ve fırsatlar
            </p>
          </div>
          <DiscountList discounts={discounts} />
        </div>
      </div>
    </main>
  );
};

export default Discounts;
